import { Component, Input } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';

@Component({
  selector: 'app-cp-reports-explanation-cards',
  templateUrl: './cp-reports-explanation-cards.component.html',
  styleUrls: ['./cp-reports-explanation-cards.component.scss']
})
export class CpReportsExplanationCardsComponent {

  @Input() titleIcon: string;
  @Input() titleText: string;
  @Input() labelText: string;
  @Input() positive: boolean;
  @Input() contentText: string;
  @Input() explanationText: string;
  @Input() hasLabel: boolean;
  @Input() noLabelText: string;

  EnumMeasureTypes = EnumMeasureTypes;

}
